import { render, staticRenderFns } from "./v-subheader.vue?vue&type=template&id=8d8c39ae&scoped=true"
import script from "./v-subheader.vue?vue&type=script&lang=js"
export * from "./v-subheader.vue?vue&type=script&lang=js"
import style0 from "./v-subheader.vue?vue&type=style&index=0&id=8d8c39ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c39ae",
  null
  
)

export default component.exports